
import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'
import LocaleController from '@/assets/controllers/LocaleController'

let backAdress = process.env.BACKADRESS
let storedImages = []
let cachedConfigs = {}

/**
 * Debounce function, taken from Underscore.js
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Boolean} immediate
 */
var debounce = function (func, wait, immediate, context) {
    this.timeout = null

    return function () {
        context = context || this
        var args = arguments
        var later = function (resolve) {
            if (!immediate) return resolve(func.apply(context, args))
        }
        var callNow = immediate && !this.timeout
        clearTimeout(this.timeout)

        if (callNow) {
            return Promise.resolve(func.apply(context, args))
        } else {
            return new Promise((resolve) => {
                this.timeout = setTimeout(() => later(resolve), wait)
            })
        }
    }
}
debounce.timeout = null
debounce.clearDebounce = () => {
    clearTimeout(debounce.timeout)
}

// Get the element with the highest occurrence in an array
const mode = function (arr) {
    return arr.sort((a, b) =>
        arr.filter(v => v === a).length -
        arr.filter(v => v === b).length
    ).pop()
}

const modeLength = function (arr) {
    return arr.filter(e => e === mode(arr)).length
}

/**
 * @param {String} baseStr
 * @param {String} maskStr
 * @param {String} char
 */
const insertChar = (baseStr, maskStr) => {
    if (baseStr === undefined || baseStr === null) {
        return undefined
    }
    var newStr = ''
    var offset = 0

    for (var i = 0; i < maskStr.length && i < baseStr.length + offset; i++) {
        if (maskStr[i] === '.') {
            newStr += '.'
            offset++
        } else {
            newStr += baseStr[i - offset]
        }
    }
    return newStr
}

const maskFactory = function (maskStr) {
    return function (o) {
        const value = o.value
        return insertChar(value, maskStr)
    }
}

const showConfirmationDialog = function (modal, wrappedCallback = () => {}, text = '?', otherOptionCallback = () => {}) {
    if (!modal) {
        modal = new Vue().$modal
    }
    modal.show({
        template: `
            <div class="confirmation-dialog-box">
                <h5 class="title"> ${text} </h5>
                <div class="dialog-button-container">
                <button class="button-default alternativeLayout modal btn-outlined" @click="handleNo"> ${LocaleController.getString('nao')} </button>
                <button class="button-default alternativeLayout modal" @click="deleteValidity"> ${LocaleController.getString('sim')} </button>
                </div>
            </div>
        `,
        methods: {
            deleteValidity () {
                wrappedCallback()
                this.close()
            },
            handleNo () {
                otherOptionCallback()
                this.close()
            },
            close () {
                this.$emit('close')
            }
        }
    }, {}, {
        height: 'auto',
        width: '800px'
    })
}

const showConfirmationDialogSync = function (modal, wrappedCallback = () => {}, text = '?', otherOptionCallback = () => {}) {
    if (!modal) {
        modal = new Vue().$modal
    }
    return new Promise((resolve, reject) => {
        modal.show({
            template: `
                <div class="confirmation-dialog-box">
                    <h5 class="title"> ${text} </h5>
                    <div class="dialog-button-container">
                    <button class="button-default alternativeLayout modal btn-outlined" @click="handleNo"> ${LocaleController.getString('nao')} </button>
                    <button class="button-default alternativeLayout modal" @click="deleteValidity"> ${LocaleController.getString('sim')} </button>
                    </div>
                </div>
            `,
            methods: {
                deleteValidity () {
                    wrappedCallback()
                    this.close()
                    resolve(true)
                },
                handleNo () {
                    otherOptionCallback()
                    this.close()
                    resolve(true)
                },
                close () {
                    this.$emit('close')
                }
            }
        }, {}, {
            height: 'auto',
            width: '800px'
        })
    })
}

const showInfoModal = function (text = '', limit = true) {
    let modal = new Vue().$modal
    text = limit ? text.substring(0, 300) : text
    let img = require('../../../static/icons/report_problem.svg')
    modal.show({
        template: `
            <div class="confirmation-dialog-box">
                <div style="display: flex; justify-content: center">
                    <img src="${img}" style="width: 96px">
                </div>
                <h5 class="title" style="padding-top: 35px"> ${text} </h5>
                <div class="dialog-button-container" style="display: block">
                    <button class="button-default alternativeLayout modal" @click="close"> OK </button>
                </div>
            </div>
        `,
        methods: {
            close () { this.$emit('close') }
        }
    },
    {},
    {
        height: 'auto',
        width: '800px'
    })
}

let isInvalidNumber = (value) => {
    return value == null || value === undefined || isNaN(value)
}

// Verifica um caso de exceção que existe na regra de imprime sim/não do FOS, que faz o preço do combo ser
// desconsiderado quando o normal, pela regra, seria considerar
const isFosException = function (product, fatherProductCode, firstLevelComboPrint, groupPrint) {
    let comboDoCombo = isComboDoCombo(product, fatherProductCode)
    let selledInsideHimself = isSelledInsideHimself(product)

    return /* firstLevelComboPrint && groupPrint && */ comboDoCombo && !selledInsideHimself
}

const isComboDoCombo = (product, fatherProductCode) => {
    return product.subItemProductGroups.length > 0 && product.subItemCode !== fatherProductCode
}

const isSelledInsideHimself = function (product) {
    let selledInsideHimself = false
    let hasProductGroups = product && product.subItemProductGroups && product.subItemProductGroups.length > 0
    if (hasProductGroups) {
        product.subItemProductGroups.forEach(subGroup => {
            let hasItems = subGroup.subProductGroupItems && subGroup.subProductGroupItems.length > 0
            if (hasItems) {
                subGroup.subProductGroupItems.forEach(subProd => {
                    if (subProd.subItemCode === product.subItemCode) {
                        selledInsideHimself = true
                    }
                })
            }
        })
    }
    return selledInsideHimself
}

/**
 * @param {Array<Object>} array
 * @param {Array<String>} keys
 */
const sortBy = function (array = [], keys = []) {
    return array.sort((a, b) => {
        for (var i = 0; i < keys.length; i++) {
            const k = keys[i]
            let diff = a[k] - b[k]
            if (isNaN(diff)) {
                const subjectA = (!!a[k] && a[k]) || ''
                const subjectB = (!!b[k] && b[k]) || ''
                diff = subjectA.localeCompare(subjectB)
            }
            if (diff !== 0) {
                return diff
            }
        }
        return 0
    })
}

const formatMoney = (value) => {
    return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value)
}

const removeBlockedProds = function (prods) {
    let blockProds = getLocalVar('blockProds') || []
    let filteredProds = (prods || []).filter(p => {
        let productCode = p.subItemCode || p.productCode
        return (blockProds.indexOf(productCode) === -1)
    })
    filteredProds = removeHiddenProducts(filteredProds)
    filteredProds = removeHourlyUnavailableProds(filteredProds)
    return filteredProds
}

const removeHiddenProducts = function (prods) {
    return (prods || []).filter(p => (p.productShowOnMenu !== 'N'))
}

const removeHourlyUnavailableProds = function (prods) {
    let hourlyUnavailableProds = getLocalVar('hourlyUnavailableProds') || []
    let filteredProds = []
    let isFirstLvlProd = prods && prods.length > 0 && prods[0].productCode !== undefined

    if (isFirstLvlProd) {
        filteredProds = (prods || []).filter(p => (hourlyUnavailableProds.indexOf(p.productCode) === -1))
    } else {
        filteredProds = (prods || []).filter(p => (hourlyUnavailableProds.indexOf(p.subItemCode) === -1))
    }

    return filteredProds
}

/**
 * Return values stored into localStorage.
 *
 * @param {String} varName
 */
const getLocalVar = function (varName) {
    let localVar = localStorage.getItem(varName)
    if (localVar) {
        return JSON.parse(localVar)
    }
    return null
}

const sleep = async (milis) => {
    return new Promise(resolve => setTimeout(resolve, milis))
}

const interfaceVersionIsSupported = (interfaceVersion, minVersionSupported) => {
    try {
        const VERSION_PARTS = 3
        let interfaceVersionParts = interfaceVersion.split('.')
        let minVersionParts = minVersionSupported.split('.')

        for (let i = 0; i < VERSION_PARTS; i++) {
            let interfaceVersionPart = interfaceVersionParts[i]
            let minVersionPart = minVersionParts[i]

            if (interfaceVersionPart.length > minVersionPart.length) {
                let zerosToAppend = interfaceVersionPart.length - minVersionPart.length
                minVersionParts[i] = appendLeftZeros(minVersionPart, zerosToAppend)
            }

            if (minVersionPart.length > interfaceVersionPart.length) {
                let zerosToAppend = minVersionPart.length - interfaceVersionPart.length
                interfaceVersionParts[i] = appendLeftZeros(interfaceVersionPart, zerosToAppend)
            }
        }

        interfaceVersion = parseInt(interfaceVersionParts.join(''))
        minVersionSupported = parseInt(minVersionParts.join(''))

        return interfaceVersion >= minVersionSupported
    } catch (error) {
        console.error(error.message)
        return false
    }
}

const appendLeftZeros = (stringToAppend, numberOfZeros) => {
    for (let i = 0; i < numberOfZeros; i++) {
        stringToAppend = '0' + stringToAppend
    }
    return stringToAppend
}

const getXMLSatMock = function () {
    return `<CFe><infCFe Id="CFe12241114200166000166599000288080016135541875" versao="0.08" versaoDadosEnt="0.08" versaoSB="050056"><ide><cUF>12</cUF><cNF>554187</cNF><mod>59</mod><nserieSAT>900028808</nserieSAT><nCFe>001613</nCFe><dEmi>20241105</dEmi><hEmi>154914</hEmi><cDV>5</cDV><tpAmb>2</tpAmb><CNPJ>16716114000172</CNPJ><signAC>SGR-SAT SISTEMA DE GESTAO E RETAGUARDA DO SAT</signAC><assinaturaQRCODE>spBoTovcbG4fDzGZSrYTBNk0/m1j42u+TXkpjlJUJuhuMXL+JhubGq1AWSFiy9z4SNiY/MSaeMQnEwoPKd8C+XD6ybLsUF7KlMilNET9ogvco+VyDpNF/KXWs6rpMB/NoEVaidzA0MF1RqyGXvXhIoqyt84Z65SmzEGF7PuitYmV2yBdWkIf7OgTY4oKk5RTPqyf6t14ltVuhrvH/LSqgQw5VZJ88F9asx2PeHaYO4DDQBtntugRvczk5g1ZOdJ+rGoFXSTn1rgSj4Fr/xAq3QkiXZdQFX1JE7fE4rV7koR/f+BUbG7WycWKBAB7S8rVYVt7pMmBz5tqR0LGeLktPQ==</assinaturaQRCODE><numeroCaixa>003</numeroCaixa></ide><emit><CNPJ>14200166000166</CNPJ><xNome>ELGIN INDUSTRIAL DA AMAZONIA LTDA</xNome><enderEmit><xLgr>AVENIDA ABIURANA</xLgr><nro>579</nro><xBairro>DIST INDUSTRIAL</xBairro><xMun>MANAUS</xMun><CEP>69075010</CEP></enderEmit><IE>111111111111</IE><cRegTrib>3</cRegTrib><indRatISSQN>N</indRatISSQN></emit><dest/><det nItem="1"><prod><cProd>9000100101</cProd><xProd>X-BACON 120GR</xProd><NCM>22021000</NCM><CFOP>5405</CFOP><uCom>UN</uCom><qCom>10.0000</qCom><vUnCom>3.500</vUnCom><vProd>35.00</vProd><indRegra>T</indRegra><vItem>35.00</vItem></prod><imposto><ICMS><ICMSSN102><Orig>0</Orig><CSOSN>500</CSOSN></ICMSSN102></ICMS><PIS><PISNT><CST>06</CST></PISNT></PIS><COFINS><COFINSNT><CST>06</CST></COFINSNT></COFINS></imposto></det><total><ICMSTot><vICMS>0.00</vICMS><vProd>35.00</vProd><vDesc>0.00</vDesc><vPIS>0.00</vPIS><vCOFINS>0.00</vCOFINS><vPISST>0.00</vPISST><vCOFINSST>0.00</vCOFINSST><vOutro>0.00</vOutro></ICMSTot><vCFe>35.00</vCFe><vCFeLei12741>1.27</vCFeLei12741></total><pgto><MP><cMP>02</cMP><vMP>35.00</vMP></MP><vTroco>0.00</vTroco></pgto><obsFisco xCampo="04.04.05.04"><xTexto>Comete crime quem sonega</xTexto></obsFisco></infCFe><Signature xmlns="http://www.w3.org/2000/09/xmldsig#"><SignedInfo><CanonicalizationMethod Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"/><SignatureMethod Algorithm="http://www.w3.org/2001/04/xmldsig-more#rsa-sha256"/><Reference URI="#CFe12241114200166000166599000288080016135541875"><Transforms><Transform Algorithm="http://www.w3.org/2000/09/xmldsig#enveloped-signature"/><Transform Algorithm="http://www.w3.org/TR/2001/REC-xml-c14n-20010315"/></Transforms><DigestMethod Algorithm="http://www.w3.org/2001/04/xmlenc#sha256"/><DigestValue>8s/Q/DRm8HoWd50iH8kD9oU7fZi3QGqk5W2W0lfSP1c=</DigestValue></Reference></SignedInfo><SignatureValue>n/8tYfSm0btUCJIO5N5e6cBqYwAMBhKhFVh/rIxKh7iAS9bO5vklMBgIxsrGlzmR5hMnquhm5Ob6VisQzN/Vmaz2QLIFSEOjwyuwg+T3Zv8otT9P0ax/cRtveWDu/J2gSWmWRPzZpxLrETDfAKRZtHEiHPP+5oILMauBpFmwcJyAm3SeO0m4WqSks983JiwW5Pkzag46TzOSu6UqwyGg5yslWDb8BXcfTB2ivo3ZOeROBrAGVSqNxP8uPIQovFkAbj8lIjsnu49KTWlyfsM3nkKusnacMh/58FbMjkvR8/IB3oMvlPjZ8n35mwY/XPioPFR2umauDwtaoTKzp/0xmw==</SignatureValue><KeyInfo><X509Data><X509Certificate>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</X509Certificate></X509Data></KeyInfo></Signature></CFe>`
}

const getLuminance = function (color) {
    const rgb = hexToRgb(color)
    // Calculate relative luminance
    const r = adjustGamma(rgb.r / 255)
    const g = adjustGamma(rgb.g / 255)
    const b = adjustGamma(rgb.b / 255)
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
    return luminance
}

const hexToRgb = function (hex) {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b)
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : null
}
const adjustGamma = function (component) {
    if (component <= 0.03928) {
        return component / 12.92
    } else {
        return Math.pow((component + 0.055) / 1.055, 2.4)
    }
}

export default {
    setAccessibilityClass () {
        document.getElementsByTagName('html')[0].classList.add('accessibility')
    },
    removeAccessibilityClass () {
        document.getElementsByTagName('html')[0].classList.remove('accessibility')
    },
    exibApartir () {
        return this.getLocalConfigs('exibApartir') === true
    },
    askPhoneNumber () {
        return this.getLocalConfigs('askPhoneNumber') === true
    },
    variablePrice: function (prod) {
        // verifica se o produto principal não imprime no cupom
        if (prod.productPrint === 'N') {
            return true
        }

        // verifica se alguma observaçao do produto principal possui preço
        if (prod.observationsChoice) {
            let observations = false
            prod.observationsChoice.forEach((e) => {
                observations = e.observations.find((obs) => {
                    return (obs.price > 0)
                })
            })
            if (observations) {
                return true
            }
        }

        // verifica os produtos filhos, se houver
        if (prod.productGroups && prod.productGroups.length > 0) {
            // verifica se algum grupo promocional imprime no cupom
            let subGroupPrint = prod.productGroups.find((e) => {
                return e.productGroupPrint === 'S'
            })
            if (subGroupPrint) return true

            // verifica se algum grupo promocional possui observações com preço
            let hasPricedObservations = false
            prod.productGroups.forEach(group => {
                if (group.productGroupItems && group.productGroupItems.length > 0) {
                    group.productGroupItems.forEach(item => {
                        if (item.subItemObservationsChoice && item.subItemObservationsChoice.length > 0) {
                            item.subItemObservationsChoice.forEach(obsGroup => {
                                if (obsGroup.subItemObservations && obsGroup.subItemObservations.length > 0) {
                                    obsGroup.subItemObservations.forEach(obs => {
                                        if (obs.price > 0) {
                                            hasPricedObservations = true
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
            if (hasPricedObservations) return true
        }

        return false
    },
    getUrlImage (path) {
        return `${this.getBackAdress()}/${path}`
    },
    logComunication: async function (uri, dataObject, _response, isXml = false) {
        try {
            const timestamp = moment().format('DD/MM/YYYY - HH:mm:ss')
            const posCode = this.getLocalConfigs('caixaCodigo')

            const logEntry = `${timestamp} | URI: ${uri}\nPayload: ${isXml ? dataObject : JSON.stringify(dataObject)}\nResponse: ${isXml ? _response : JSON.stringify(_response)}\n\n\n`

            if (!this.isOracle()) {
                const urlMenuCache = this.getBackAdress()

                // 4. Preparar payload uma única vez
                const logPayload = {
                    device: 'TAA',
                    posCode: posCode,
                    log: logEntry
                }

                // 5. Requisição assíncrona com timeout e tratamento de erro
                await axios.post(urlMenuCache + '/generateLog', logPayload, {
                    timeout: 3000, // Timeout reduzido para logs
                    validateStatus: () => true // Aceitar qualquer status
                }).catch(error => {
                    // Tratamento silencioso de erro (não propagar)
                    console.warn('Log send failed:', error.message)
                })
            }
        } catch (error) {
            // Tratamento de erro completo mas silencioso
            console.warn('Log function error:', error.message)
        }

        // 6. Sempre retornar Promise resolvida (não bloquear chamador)
        return Promise.resolve()
    },
    logUsage: async function (type, log) {
        let useLogUsage = this.getLocalConfigs('useLogUsage')
        if (!useLogUsage) {
            return
        }
        try {
            const timestamp = moment().format('DD/MM/YYYY - HH:mm:ss')
            const posCode = this.getLocalConfigs('caixaCodigo')
            if (log === 'sessao_totem_finalizada') {
                log = log += '\n\n'
            }
            const logEntry = `${timestamp} | ${type} - ${log}\n`

            if (!this.isOracle()) {
                const urlMenuCache = this.getBackAdress()

                // 4. Preparar payload uma única vez
                const logPayload = {
                    device: 'TAA',
                    posCode: posCode,
                    log: logEntry
                }

                // 5. Requisição assíncrona com timeout e tratamento de erro
                await axios.post(urlMenuCache + '/generateLogUsage', logPayload, {
                    timeout: 3000, // Timeout reduzido para logs
                    validateStatus: () => true // Aceitar qualquer status
                }).catch(error => {
                    // Tratamento silencioso de erro (não propagar)
                    console.warn('Log send failed:', error.message)
                })
            }
        } catch (error) {
            // Tratamento de erro completo mas silencioso
            console.warn('Log function error:', error.message)
        }

        // 6. Sempre retornar Promise resolvida (não bloquear chamador)
        return Promise.resolve()
    },
    getAvailableInterfaces (endApache) {
        return axios.post(endApache + 'rest-api/')
    },
    getDateAsFormat (format) {
        return moment().format(format)
    },

    /**
     * Quebra um nível do objeto e o retorna como array
     *
     * */
    flatAnObjectList: function (obj) {
        return Object.values(obj).flat(1)
    },

    /**
     * Store values into localStorage.
     *
     * @param {String} varName
     * @param {*} value
     */
    setLocalVar (varName, value) {
        localStorage.setItem(varName, JSON.stringify(value))
    },

    createInitialConfig () {
        let config = {
            urlOdhenInterface: '',
            urlIMGOdhenInterface: '',
            balancaport: '',
            sitefAddress: '',
            urlPerifericos: process.env.urlPerifericos || 'http://127.0.0.1:3000/',
            isEditMode: false,

            primary_color: `${getComputedStyle(document.body).getPropertyValue('--primary-color')}`.trim(),
            primary_light: `${getComputedStyle(document.body).getPropertyValue('--primary-light')}`.trim(),
            primary_dark: `${getComputedStyle(document.body).getPropertyValue('--primary-dark')}`.trim(),
            header_color: `${getComputedStyle(document.body).getPropertyValue('--header-color')}`.trim(),
            categorie_color: `${getComputedStyle(document.body).getPropertyValue('--categorie-color')}`.trim(),
            categorie_font_color: `${getComputedStyle(document.body).getPropertyValue('--categorie-font-color')}`.trim(),
            cart_color: `${getComputedStyle(document.body).getPropertyValue('--cart-color')}`.trim(),
            cart_font_color: `${getComputedStyle(document.body).getPropertyValue('--cart-font-color')}`.trim(),
            price_font_color: `${getComputedStyle(document.body).getPropertyValue('--price-font-color')}`.trim(),

            boldPrice: false,
            consumidorTipo: null,
            taas: [],
            comprimentoNSU: null,
            nomeDoDispositivo: process.env.nomeDoDispositivo,
            caixaCodigo: process.env.caixaCodigo,
            filialCodigo: process.env.filialCodigo,
            lojaCodigo: process.env.lojaCodigo,
            cardapioExpira: false,
            modotap: false,
            slimMode: false,
            enableProdBarCodeRead: false,
            acessibilidade: false,
            modobalanca: false,
            shouldAutoClose: false,
            homologPay: false,
            curtaa: {},

            images: {},
            metodosPagamento: [],
            tiposRecebimento: null,
            modeEntrega: [],
            modeEntregaDrive: [],
            tipoCaixa: 'venda',
            tipoTEF: null,
            modeloImpressora: null,
            nomeImpressora: null,
            portaImpressora: 'USB',
            emissaoFiscal: null,
            produtoSemfoto: true,
            exibApartir: false,
            exibeContinuarComprando: false,
            removeConfirmImpressaoCupom: false,
            kioskPort: 0,
            usePager: false,
            useBarcode: false,
            allowMultipleAdd: true,
            enableSubgroups: true,
            permiteObsDigitada: false,
            itemsList: false,
            imprimeEspelho: true,
            hideGroupOnMax: false,
            fixedServiceTax: false,
            iconesGrandes: false,
            showMinPriceDifference: false,
            useAlternativeLayout: true,
            utiliza_layout_gom: false,
            mainLanguage: [],
            idiomaAdic_pt_br: [],
            idiomaAdic_en: [],
            idiomaAdic_es: [],
            companyCodCRM: '',
            authCRM: '',
            apiUrlCRM: '',
            timeOut: 150,
            timeOutInModal: 30,
            enableJumpGroup: false,
            printTokens: false
        }
        this.setLocalVar('taaconfig', config)
        return config
    },

    getLocalConfigs: function (value) {
        if (!cachedConfigs || Object.keys(cachedConfigs).length === 0) {
            cachedConfigs = JSON.parse(localStorage.getItem('taaconfig'))
        }
        // let config = JSON.parse(localStorage.getItem('taaconfig'));
        if (cachedConfigs) {
            return (cachedConfigs && cachedConfigs[value]) || null
        }
        return null
    },

    reloadcachedConfigs: function () {
        cachedConfigs = JSON.parse(localStorage.getItem('taaconfig'))
    },

    isOracle () {
        const env = process.env
        return env['ISORACLE'] === 'true'
    },

    isTapMode () { return this.getLocalConfigs('modotap') === true },

    isBalancaMode () { return this.getLocalConfigs('modobalanca') === true },

    isSlimMode () { return this.getLocalConfigs('slimMode') === true },

    useBoldPrice () { return this.getLocalConfigs('boldPrice') === true },

    allowAcessibilidade () { return this.getLocalConfigs('acessibilidade') === true },

    allowProdBarCodeRead () { return this.getLocalConfigs('enableProdBarCodeRead') === true },

    isEditMode () { return this.getLocalConfigs('isEditMode') === true },

    isAndroidMode () { return this.getLocalVar('runningEnvironment') && this.getLocalVar('runningEnvironment').insideAndroid === true },

    getModelAndroid () {
        let model = this.getLocalVar('runningEnvironment')
        return (model && model.model) || ''
    },
    getManufacturerAndroid () {
        // androids homologados
        // gertec sk210, asus ww_Tinker_board, tectoy k2, tectoy k2 mini, Wiseasy (Transire T2)
        let model = this.getLocalVar('runningEnvironment')
        return (model && model.manufacturer) || ''
    },
    isTectoy () {
        let insideAndroid = (this.getLocalVar('runningEnvironment') && this.getLocalVar('runningEnvironment').insideAndroid) || false
        if (!insideAndroid) {
            return false
        }
        let model = (this.getLocalVar('runningEnvironment').model || '').toLowerCase()
        let manufacturer = (this.getLocalVar('runningEnvironment').manufacturer || '').toLowerCase()
        if (manufacturer === 'tectoy' || model === 'k2' || model === 'k2_mini' || manufacturer === 'sunmi') {
            return true
        }
        return false
    },
    isTransire () {
        let insideAndroid = (this.getLocalVar('runningEnvironment') && this.getLocalVar('runningEnvironment').insideAndroid) || false
        if (!insideAndroid) {
            return false
        }
        let model = (this.getLocalVar('runningEnvironment').model || '').toLowerCase()
        let manufacturer = (this.getLocalVar('runningEnvironment').manufacturer || '').toLowerCase()
        if (manufacturer === 'wiseasy' || model === 't2') {
            return true
        }
        return false
    },

    addprodTAP () { return this.getLocalConfigs('addprodTAP') === true },

    autoOpenCommand () { return this.getLocalConfigs('autoOpenCommand') === true },

    isHybridMode () { this.getLocalConfigs('hybridMode') },

    isNfseMode () {
        let curtaa = this.getLocalConfigs('curtaa')
        return curtaa != null && curtaa.useNFSe === 'S'
    },
    printBalance () {
        // 0 - Imprime saldo TOTAL
        // 1 - Imprime saldo por familia
        return this.getLocalConfigs('printBalanceCons')
    },
    isInfoConsTaa () {
        // Solicita o consumidor para todos os tipos de pagamento
        return this.getLocalConfigs('infoConsTaa')
    },
    isLockKeyboardCons () {
        // Faz login apenas com o cracha do consumidor
        return this.getLocalConfigs('lockKeyboardCons')
    },
    isGertecSk210 () {
        let moldel = this.getLocalVar('runningEnvironment')
        return moldel && moldel.insideAndroid === true && (moldel.manufacturer || '').toLowerCase() === 'gertec'
    },

    showConsumerLogin () { return true },

    getGeneralInfo (force = false) {
        return {
            'subsidiaryCode': this.getLocalConfigs('filialCodigo'),
            'storeCode': this.getLocalConfigs('lojaCodigo'),
            'posCode': this.getLocalConfigs('caixaCodigo'),
            'consumerType': this.getLocalConfigs('consumidorTipo'),
            'hour': moment().format('HH:mm'),
            'force': force,
            'posName': this.getLocalConfigs('nomeDoDispositivo'),
            'clientId': this.getLocalVar('clientId')
        }
    },

    getFaceRecognitionParams () {
        // "recognize" é o endpoint para reconhecimento facial
        const linkApi = this.getLocalConfigs('faceRecognitionApi') // 'https://face-recognition-api.teknisa.com/'
        console.log('linkApi', linkApi)
        const colectionCode = this.getLocalConfigs('orgMode')
        return {linkApi: linkApi, colectionCode: colectionCode}
    },

    setLocalStoredColors () {
        let config = this.getLocalVar('taaconfig')
        if (config) {
            let r = document.querySelector(':root')
            r.style.setProperty('--primary-color', config.primary_color)
            r.style.setProperty('--primary-light', config.primary_light)
            r.style.setProperty('--primary-dark', config.primary_dark)
            r.style.setProperty('--header-color', config.header_color)
            r.style.setProperty('--categorie-color', config.categorie_color)
            r.style.setProperty('--categorie-font-color', config.categorie_font_color)
            r.style.setProperty('--cart-color', config.cart_color)
            r.style.setProperty('--cart-font-color', config.cart_font_color)
            r.style.setProperty('--price-font-color', config.price_font_color)
        }
    },

    /**
     * Show information notification
     *
     * @param {Object} message
     */
    showNotification (message) {
        Vue.notify({
            group: 'main',
            title: message.title,
            text: message.text
        })
    },

    /**
     * Show warning notification
     *
     * @param {Object} message
     */
    showWarningNotification (message) {
        Vue.notify({
            group: 'main',
            type: 'warn',
            title: message.title,
            text: message.text
        })
    },

    /**
     * Show error notification
     *
     * @param {Object} message
     */
    showErrorNotification (message) {
        Vue.notify({
            group: 'main',
            type: 'error',
            title: message.title || message,
            text: message.text
        })
    },

    showErrorNotificationFixed (message) {
        Vue.notify({
            group: 'main',
            type: 'error',
            title: message.title,
            text: message.text,
            duration: -1
        })
    },

    /**
     * Show success notification
     *
     * @param {Object} message
     */
    showSuccessNotification (message) {
        Vue.notify({
            group: 'main',
            type: 'success',
            title: message.title,
            text: message.text
        })
    },

    spliceOnCondition (array, callback) {
        var i = array.length
        while (i--) {
            if (callback(array[i], i)) {
                array.splice(i, 1)
            }
        }
    },

    arrayToOjbect (source) {
        source = source || []
        return source.reduce((acc, cur) => {
            let key = Object.keys(cur)[0]
            acc[key] = cur[key]
            return acc
        }, {})
    },

    safeDecimalCalc: function (param1, param2, symbol) {
        let knowFunctions = {
            '+': ((param1 * 100) + (param2 * 100)) / 100,
            '-': ((param1 * 100) - (param2 * 100)) / 100
        }
        return knowFunctions[symbol]
    },

    deepCopy (source) {
        return JSON.parse(JSON.stringify(source))
    },
    isTimeToReloadFoodMenu () {
        if (this.getLocalConfigs('hotReload') === true) {
            return true
        }
        let respectExpiration = (process.env.RESPECT_EXPIRATION_CONFIG === true && this.getLocalConfigs('cardapioExpira') === true) || (process.env.RESPECT_EXPIRATION_CONFIG === false)
        if (respectExpiration) {
            let now = moment()
            let lastSync = this.getLocalVar('lastSync')
            let lastSyncDiff = null
            try {
                lastSyncDiff = now.diff(moment(lastSync, 'MMDDHHmm'), 'minutes')
            } catch (e) {
                lastSyncDiff = null
            }
            let isTimeToReload = (lastSyncDiff === null || isNaN(lastSyncDiff) || lastSyncDiff > 30)
            return isTimeToReload
        }
        return moment().format('MMDD') !== this.getLocalVar('lastSync')
    },
    updateLastSync () {
        this.setLocalVar('lastSync', moment().format('MMDD'))
        if ((process.env.RESPECT_EXPIRATION_CONFIG === true && this.getLocalConfigs('cardapioExpira') === true) || process.env.RESPECT_EXPIRATION_CONFIG === false) {
            this.setLocalVar('lastSync', moment().format('MMDDHHmm'))
        }
    },
    mode,
    modeLength,
    sortBy,
    debounce,
    insertChar,
    maskFactory,
    showConfirmationDialog,
    showInfoModal,
    isInvalidNumber,
    formatMoney,
    isFosException,
    isComboDoCombo,
    getLocalVar,
    removeBlockedProds,
    removeHiddenProducts,
    removeHourlyUnavailableProds,
    sleep,
    interfaceVersionIsSupported,
    toBase64 (file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })
    },
    getConfigImage: function (file) {
        /* if (this.isOracle()) {
            return storedImages[file] && storedImages[file].image || null
        } else {
            let image = this.getLocalConfigs('images') && this.getLocalConfigs('images')[file] || null
            return image ? `${this.getBackAdress()}/${image}` : null
        } */
        return (storedImages[file] && storedImages[file].image) || null
    },
    getBackAdress () {
        const ipAddress = window.location.hostname
        backAdress = `http://${ipAddress}:1812`
        return backAdress
    },
    setBackAdress () {
        const ipAddress = window.location.hostname
        backAdress = `http://${ipAddress}:1812`
    },
    generateProdList (products) {
        let observations = []
        let prodList = products.map(p => {
            if (p.products && p.products.length > 0) {
                let prods = p.products
                let subGroupProductItens = []
                prods.forEach(p => {
                    (p.productGroups || []).forEach(pg => {
                        let pgitens = pg.productGroupItems.map(pgi => pgi).flat(1)
                        subGroupProductItens = subGroupProductItens.concat(pgitens)
                        if (pg.observationsChoice && pg.observationsChoice.length > 0) {
                            pg.observationsChoice.forEach((obsGroup) => {
                                let newObs = (obsGroup.observations || []).filter((obs) => {
                                    return !!obs.obsProductCode && obs.obsType === 'A' &&
                                            observations.findIndex((e) => e.obsProductCode === obs.obsProductCode) === -1
                                })
                                observations = observations.concat(newObs)
                            })
                        }
                    })
                    if (p.observationsChoice && p.observationsChoice.length > 0) {
                        p.observationsChoice.forEach((obsGroup) => {
                            let newObs = (obsGroup.observations || []).filter((obs) => {
                                return !!obs.obsProductCode && obs.obsType === 'A' && observations.findIndex((e) => e.obsProductCode === obs.obsProductCode) === -1
                            })
                            observations = observations.concat(newObs)
                        })
                    }
                })
                return prods.concat(subGroupProductItens)
            } else if (p.subGroups && p.subGroups.length > 0) {
                let subGroupProduct = p.subGroups.map(s => s.products).flat(1)
                let subGroupProductItens = []
                subGroupProduct.forEach((sub) => {
                    if (sub.observationsChoice && sub.observationsChoice.length > 0) {
                        sub.observationsChoice.forEach((obsGroup) => {
                            let newObs = (obsGroup.observations || []).filter((obs) => {
                                return !!obs.obsProductCode && obs.obsType === 'A' && observations.findIndex((e) => e.obsProductCode === obs.obsProductCode) === -1
                            })
                            observations = observations.concat(newObs)
                        })
                    }
                })
                p.subGroups.forEach(p => {
                    (p.productGroups || []).forEach(pg => {
                        let pgitens = pg.productGroupItems.map(pgi => pgi).flat(1)
                        subGroupProductItens = subGroupProductItens.concat(pgitens)
                        if (pg.observationsChoice && pg.observationsChoice.length > 0) {
                            pg.observationsChoice.forEach((obsGroup) => {
                                let newObs = (obsGroup.observations || []).filter((obs) => {
                                    return !!obs.obsProductCode && obs.obsType === 'A' && observations.findIndex((e) => e.obsProductCode === obs.obsProductCode) === -1
                                })
                                observations = observations.concat(newObs)
                            })
                        }
                    })
                })
                return subGroupProduct.concat(subGroupProductItens)
            } else {
                return []
            }
        }).flat(1)
        observations = observations.map((e) => {
            return {
                productCode: e.obsProductCode,
                productName: 'OBS ' + e.obsName
            }
        })
        observations = observations.filter((o) => {
            return prodList.findIndex(e => e.productCode === o.productCode) === -1
        })
        prodList = prodList.concat(observations)
        return prodList
    },
    removePixSaquePixTroco: function (optionsArray) {
        let filteredOptions = optionsArray.filter(option => option.name !== 'Pix Saque' && option.name !== 'Pix Troco')
        return filteredOptions
    },
    showErrorScreen: function (router, errorType) {
        router.push({
            name: 'ErrorScreen',
            params: { errorType }
        })
        return true
    },
    validPhoneNumber: function (phoneNumber) {
        let regex = null
        let ddi = '+55' // this.phoneNumber.substring(0, 3)
        phoneNumber = phoneNumber.replace(/[^\d]+/g, '')
        if (ddi === '+55') {
            regex = new RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|(9[0-9]{3}[0-9]{5}))$')
            return regex.test(phoneNumber)
        } else {
            regex = new RegExp(/^(\d)\1+$/)
            return !regex.test(phoneNumber) && (phoneNumber.length > 6)
        }
    },
    sanitizePhoneNumber: function (phoneNumber) {
        phoneNumber = phoneNumber.replace(/[^\d]+/g, '')
        return phoneNumber
    },
    getImageList: function () {
        return [
            {
                id: 'espera',
                label: LocaleController.getString('imagem_tela_de_espera'),
                size: '(1080 x 1920)'
            },
            {
                id: 'logo',
                label: LocaleController.getString('logo'),
                size: '(400 x 150)'
            },
            {
                id: 'noImage',
                label: LocaleController.getString('produtos_sem_foto'),
                size: '(500 x 500)'
            },
            {
                id: 'toGo',
                label: LocaleController.getString('levar'),
                size: '(500 x 500)'
            },
            {
                id: 'comerAqui',
                label: LocaleController.getString('comer_aqui'),
                size: '(500 x 500)'
            },
            {
                id: 'pager',
                label: LocaleController.getString('instrucoes_pager'),
                size: '(1080 x 1920)'
            },
            {
                id: 'balancascreen',
                label: LocaleController.getString('instrucoes_balanca'),
                size: '(1080 x 1920)'
            },
            {
                id: 'tapscreen',
                label: LocaleController.getString('instrucoes_TAP'),
                size: '(1080 x 1920)'
            },
            {
                id: 'maquininha',
                label: LocaleController.getString('instrucoes_da_maquininha'),
                size: '(800 x 1000)'
            },
            {
                id: 'impressora',
                label: LocaleController.getString('instrucoes_da_impressora'),
                size: '(800 x 1000)'
            },
            {
                id: 'erroImpressora',
                label: LocaleController.getString('erro_de_impressora'),
                size: '(1080 x 1920)'
            },
            {
                id: 'erroSalvarVenda',
                label: LocaleController.getString('erro_ao_salvar_venda'),
                size: '(1080 x 1920)'
            },
            {
                id: 'erroTEF',
                label: LocaleController.getString('erro_de_pinpad'),
                size: '(1080 x 1920)'
            },
            {
                id: 'erroPinpad',
                label: LocaleController.getString('erro_pinpad_2'),
                size: '(1080 x 1920)'
            }
        ]
    },
    getImagesUrl: function (prod, prop, size) {
        let baseUrl = this.isOracle() ? this.getLocalVar('imgOnlineBaseURL') : this.getLocalConfigs('urlIMGOdhenInterface')
        // let uri = (prod[prop] && prod[prop][0][size]) || null
        let uri = (prod[prop] && prod[prop][0] && prod[prop][0][size]) || (prod && prod[prop] && prod[prop][size]) || ''
        if (uri.startsWith('http://') || uri.startsWith('https://')) {
            return uri
        }
        if (baseUrl && uri) {
            return baseUrl + uri
        }
        return null
    },
    getTLSTefConfig: function () {
        let config = {}
        config.CDTOKENTLS = this.getLocalConfigs('tefToken') || ''
        config.CDTPCOMUNTLS = this.getLocalConfigs('tefCommunic') || ''
        config.CDTPPROXYTLS = this.getLocalConfigs('tefProxyType') || ''
        config.CDENPROXYTLS = this.getLocalConfigs('tefEndProxy') || ''
        return config
    },
    exibQrCodePinPad: function () {
        return this.getLocalConfigs('exibQrCodePinPad') === true
    },
    imprimeTefReduzido: function () {
        return this.getLocalConfigs('imprimeTefReduzido') === true
    },
    removeBlockedProdsObs: function (obs) {
        let blockProds = this.getLocalVar('blockProds') || []
        if (!Array.isArray(obs)) {
            return []
        }
        let filteredObs = (obs || []).filter((p) => {
            let productCode = p.obsProductCode || p.subItemObsProductCode
            let obsPrintOnApp = p.obsPrintOnApp || p.subItemObsPrintOnApp
            return (blockProds.indexOf(productCode) === -1 && obsPrintOnApp !== 'N')
        })
        return filteredObs
    },
    setStoredImages: function (images) {
        storedImages = images
    },
    getXMLSatMock,
    idealTextColor: function (bgColor) {
        const luminance = getLuminance(bgColor)
        return (luminance > 0.4)
    },
    flattenXmlTextFields: function (obj) {
        if (obj === null || typeof obj !== 'object') {
            return obj
        }

        if (Array.isArray(obj)) {
            return obj.map(item => this.flattenXmlTextFields(item))
        }

        const keys = Object.keys(obj)

        // Se o objeto está vazio, retorna null
        if (keys.length === 0) {
            return null
        }

        // Se o objeto tem apenas _text, retorna o valor do _text
        if (keys.length === 1 && keys[0] === '_text') {
            return obj._text
        }

        // Se o objeto tem _text (mesmo com outras propriedades), retorna o valor do _text
        // Isso cobre casos onde o XML tem atributos adicionais junto com o texto
        if (obj.hasOwnProperty('_text')) {
            return obj._text
        }

        // Para objetos sem _text, processa recursivamente cada propriedade
        const result = {}
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                result[key] = this.flattenXmlTextFields(obj[key])
            }
        }

        return result
    },
    showConfirmationDialogSync
}



// WEBPACK FOOTER //
// ./src/assets/libs/util.js